import { BREW_METHODS, ROASTS, TASTE_PROFILES } from '@c214/shared';
import type { Filters } from '../../hooks/useProductFilters';
import { Chip } from '../ui/chip';

interface Props {
  filters: Filters;
  setFilter: <K extends keyof Filters>(key: K, value: Filters[K]) => void;
  regions: string[];
}

export function FilterGroups({ filters, setFilter, regions }: Props) {
  const groups = [
    {
      label: 'Обсмаження',
      key: 'roast' as const,
      options: [{ key: 'all' as const, label: 'Усі' }, ...ROASTS],
    },
    {
      label: 'Профіль смаку',
      key: 'profile' as const,
      options: [{ key: 'all' as const, label: 'Усі' }, ...TASTE_PROFILES],
    },
    {
      label: 'Спосіб заварювання',
      key: 'brew' as const,
      options: [{ key: 'all' as const, label: 'Усі' }, ...BREW_METHODS],
    },
    {
      label: 'Регіон',
      key: 'region' as const,
      options: [
        { key: 'all' as const, label: 'Усі' },
        ...regions.map((region) => ({ key: region, label: region })),
      ],
    },
  ];

  return (
    <div className="mb-10 grid gap-6 [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))]">
      {groups.map((group) => (
        <div key={group.key}>
          <p className="mono-label mb-[10px] text-[10px]">{group.label}</p>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => (
              <Chip
                key={option.key}
                active={filters[group.key] === option.key}
                onClick={() => setFilter(group.key, option.key as never)}
              >
                {option.label}
              </Chip>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
